// src/pages/home/HomeMobile.jsx

import React from "react";
import { Link } from "react-router-dom";
import "./homeMobile.css";

const HomeMobile = () => (
    <div
        className="home-container-mobile bg-reveal"
        data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_home.png`}
    >
        <div className="home-content-mobile">
            <h1>Willkommen im FestivalPortal</h1>
            <p>Registriere dich oder melde dich an, um fortzufahren.</p>

            <div className="home-button-container-mobile">
                <Link to="/login">
                    <button className="home-button">Login</button>
                </Link>
                <Link to="/register">
                    <button className="home-button">Registrieren</button>
                </Link>
            </div>
        </div>
    </div>
);

export default HomeMobile;
